import * as z from "zod";
import {
  CommonMetadataSchema,
  type ManifestValidationResult,
  validateManifest,
} from "./_shared.js";

export const PersonaManifestSchema = z.looseObject({
  name: z.string().min(1),
  description: z.string().min(1),
  version: z.string().optional(),
  keywords: z.array(z.string()).optional(),
  license: z.string().optional(),
  metadata: CommonMetadataSchema.optional(),
});

export type PersonaManifest = z.infer<typeof PersonaManifestSchema>;

export function validatePersona(data: unknown): ManifestValidationResult<PersonaManifest> {
  return validateManifest(PersonaManifestSchema, data);
}
